export default __webpack_public_path__ + "static/projectSectionMobileBackground-634f9eec134c8cf285539b8835c5940b.png";